export default "__VITE_ASSET__888c566f__"